// utils/passwordValidation.js
// ולידציית סיסמה משותפת — ChangePasswordDialog + AdminUsers
//
// Rules (from API docs):
//   מינימום 8 תווים, אות גדולה, אות קטנה, ספרה, תו מיוחד

export const PASSWORD_RULES = [
  { key: 'minLength', test: (p) => p.length >= 8 },
  { key: 'uppercase', test: (p) => /[A-Z]/.test(p) },
  { key: 'lowercase', test: (p) => /[a-z]/.test(p) },
  { key: 'digit', test: (p) => /\d/.test(p) },
  { key: 'special', test: (p) => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(p) },
];

export function validatePassword(password) {
  return PASSWORD_RULES.map((rule) => ({
    ...rule,
    passed: rule.test(password),
  }));
}

export function isPasswordValid(password) {
  return PASSWORD_RULES.every((rule) => rule.test(password));
}
